import React, { useState, useEffect } from 'react';
import { BCAttestationRow } from '../BCAttestationRow';
import { translate } from '../../../Services/translation';
import { BCTabContainer } from './BCTabContainer';
import { useBCApi } from '../hooks/BCApi';
import { post } from '../../../Services/http';
import { BCSpinner } from '../BCSpinner';

export const Attestations = () => {
    const [attestations, setAttestations] = useState([]);

    const { value, error, execute, status } = useBCApi(
        '/api/bcmypages/attestations',
        true
    );

    useEffect(() => {
        if (status === 'success') {
            setAttestations(value.orders);
        }
    }, [status, value?.orders]);

    const handleApprove = async (order) => {
        const response = await post('/api/bcmypages/attestations/approve', {
            id: order.orderId,
        });

        if (response.status === 200) {
            await execute();
        }
    };

    const handleDecline = async (order, reason) => {
        const response = await post('/api/bcmypages/attestations/decline', {
            id: order.orderId,
            reason: reason,
        });

        if (response.status === 200) {
            execute();
        }
    };

    const renderBody = () => {
        if (error)
            return (
                <div className="BusinessCentral_AttestationTab__container__content__table__body__error">
                    {translate('business.attestationtab.fetcherror')}
                </div>
            );

        if (status === 'pending')
            return (
                <div className="BusinessCentral_AttestationTab__container__content__table__body__loading">
                    <BCSpinner />
                </div>
            );

        if (value?.orders.length > 0)
            return attestations.map((attestation, index) => (
                <BCAttestationRow
                    key={index}
                    order={attestation}
                    onApprove={handleApprove}
                    onDecline={handleDecline}
                    isApprover={value?.isApprover}
                />
            ));

        return (
            <div className="BusinessCentral_AttestationTab__container__content__table__body__empty">
                {translate('business.attestationtab.empty')}
            </div>
        );
    };

    return (
        <BCTabContainer title={translate('business.attestations.header')}>
            <div className="BusinessCentral_AttestationTab__container__content">
                <div className="BusinessCentral_AttestationTab__container__content__table">
                    <div className="BusinessCentral_AttestationTab__container__content__table__header">
                        <div className="BusinessCentral_AttestationTab__container__content__table__header__item">
                            {translate('business.attestationTab.ordernumber')}
                        </div>

                        <div className="BusinessCentral_AttestationTab__container__content__table__header__item">
                            {translate('business.attestationTab.orderdate')}
                        </div>

                        <div className="BusinessCentral_AttestationTab__container__content__table__header__item">
                            {translate('business.attestationTab.orderplacer')}
                        </div>

                        <div className="BusinessCentral_AttestationTab__container__content__table__header__item">
                            {translate('business.attestationTab.reference')}
                        </div>

                        <div className="BusinessCentral_AttestationTab__container__content__table__header__item">
                            {translate('business.attestationTab.pricevat')}
                        </div>
                    </div>
                    <div className="BusinessCentral_AttestationTab__container__content__table__body">
                        {renderBody()}
                    </div>
                </div>
            </div>
        </BCTabContainer>
    );
};
